/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview The interface for a Blockly component that can be registered.
 *    (Ex. Toolbox, Fields, Renderers)
 * @author aschmiedt@google.com (Abby Schmiedt)
 */

'use strict';

goog.provide('Blockly.IRegistrable');


/**
 * The interface for a Blockly component that can be registered.
 * @interface
 */
Blockly.IRegistrable = function() {};
